/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Match } from './Match';
import {
    MatchFromJSON,
    MatchFromJSONTyped,
    MatchToJSON,
} from './Match';
import type { Person } from './Person';
import {
    PersonFromJSON,
    PersonFromJSONTyped,
    PersonToJSON,
} from './Person';
import type { Player } from './Player';
import {
    PlayerFromJSON,
    PlayerFromJSONTyped,
    PlayerToJSON,
} from './Player';
import type { TeamDetails } from './TeamDetails';
import {
    TeamDetailsFromJSON,
    TeamDetailsFromJSONTyped,
    TeamDetailsToJSON,
} from './TeamDetails';
import type { TeamMeta } from './TeamMeta';
import {
    TeamMetaFromJSON,
    TeamMetaFromJSONTyped,
    TeamMetaToJSON,
} from './TeamMeta';
import type { TeamStatus } from './TeamStatus';
import {
    TeamStatusFromJSON,
    TeamStatusFromJSONTyped,
    TeamStatusToJSON,
} from './TeamStatus';
import type { TournamentCategory } from './TournamentCategory';
import {
    TournamentCategoryFromJSON,
    TournamentCategoryFromJSONTyped,
    TournamentCategoryToJSON,
} from './TournamentCategory';

/**
 * 
 * @export
 * @interface Team
 */
export interface Team {
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    clubName?: string;
    /**
     * 
     * @type {TournamentCategory}
     * @memberof Team
     */
    category?: TournamentCategory;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    gender?: string;
    /**
     * 
     * @type {TeamStatus}
     * @memberof Team
     */
    status?: TeamStatus;
    /**
     * 
     * @type {TeamMeta}
     * @memberof Team
     */
    meta?: TeamMeta;
    /**
     * 
     * @type {Array<Match>}
     * @memberof Team
     */
    matches?: Array<Match>;
    /**
     * 
     * @type {TeamDetails}
     * @memberof Team
     */
    details?: TeamDetails;
    /**
     * 
     * @type {Array<Player>}
     * @memberof Team
     */
    players?: Array<Player>;
    /**
     * 
     * @type {Array<Person>}
     * @memberof Team
     */
    officials?: Array<Person>;
}

/**
 * Check if a given object implements the Team interface.
 */
export function instanceOfTeam(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TeamFromJSON(json: any): Team {
    return TeamFromJSONTyped(json, false);
}

export function TeamFromJSONTyped(json: any, ignoreDiscriminator: boolean): Team {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'clubName': !exists(json, 'clubName') ? undefined : json['clubName'],
        'category': !exists(json, 'category') ? undefined : TournamentCategoryFromJSON(json['category']),
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'status': !exists(json, 'status') ? undefined : TeamStatusFromJSON(json['status']),
        'meta': !exists(json, 'meta') ? undefined : TeamMetaFromJSON(json['meta']),
        'matches': !exists(json, 'matches') ? undefined : ((json['matches'] as Array<any>).map(MatchFromJSON)),
        'details': !exists(json, 'details') ? undefined : TeamDetailsFromJSON(json['details']),
        'players': !exists(json, 'players') ? undefined : ((json['players'] as Array<any>).map(PlayerFromJSON)),
        'officials': !exists(json, 'officials') ? undefined : ((json['officials'] as Array<any>).map(PersonFromJSON)),
    };
}

export function TeamToJSON(value?: Team | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'clubName': value.clubName,
        'category': TournamentCategoryToJSON(value.category),
        'gender': value.gender,
        'status': TeamStatusToJSON(value.status),
        'meta': TeamMetaToJSON(value.meta),
        'matches': value.matches === undefined ? undefined : ((value.matches as Array<any>).map(MatchToJSON)),
        'details': TeamDetailsToJSON(value.details),
        'players': value.players === undefined ? undefined : ((value.players as Array<any>).map(PlayerToJSON)),
        'officials': value.officials === undefined ? undefined : ((value.officials as Array<any>).map(PersonToJSON)),
    };
}

